import React from "react"
import CustomerLoginButtons from "./CustomerLoginButtons"
import "./CustomerInfo.css"
import GuestForm from "./GuestForm"
import EmailLoginForm from "./EmailLoginForm"
import CheckSteps from "../CheckSteps"
import {
  getBuyerGoogleDetails,
  getBuyerFacebookDetails
} from "../../customer-account/customerAccountAPI"

function CustomerInfo({
  info,
  chooseLogin,
  setCustomerData,
  customerData,
  setCustomerAddress,
  deliveryData,
  setSteps,
  steps,
  setActiveStep,
  checkoutMethod,
  setCheckoutMethod,
  backHandler,
  uuid,
  account_uuid,
  showAccountRegister,
  handleForgotPassword,
  hideForgotPassword,
  handleShowVerifyEmail,
  hideVerifyEmail,
  setCustomerStatus,
  isNewOrder,
  newOrderAccountUuid
}) {
  function guestLoginHandler() {
    chooseLogin && chooseLogin("guest")
  }
  function emailLoginHandler() {
    chooseLogin && chooseLogin("email")
  }
  async function facebookLoginHandler() {
    try {
      const userDetails = await getBuyerFacebookDetails(account_uuid, uuid)
      // const { customer } = response
      // const adr = customer.address
      chooseLogin && chooseLogin("facebook")
      // setCustomerAddress({
      //   addressOne: adr.address_line_1 || "",
      //   addressTwo: adr.address_line_2 || "",
      //   city: adr.city || "",
      //   country:
      //     (adr.country && { value: adr.country, label: adr.country }) || "",
      //   state:
      //     (adr.province && { value: adr.province, label: adr.province }) || "",
      //   zipcode: adr.zipcode || ""
      // })
      setCustomerData({
        firstName: (userDetails && userDetails.firstName) || "",
        lastName: (userDetails && userDetails.lastName) || "",
        // email: (userDetails && userDetails.email) || "",
        method: "facebook"
      })
      setActiveStep("shipping")
      setCheckoutMethod("facebook")
    } catch (error) {
      console.log(error.response || error)
    }
  }
  async function googleLoginHandler() {
    try {
      const userDetails = await getBuyerGoogleDetails(account_uuid, uuid)
      console.log("response:", userDetails)
      // const adr = customer.address
      chooseLogin && chooseLogin("google")
      // setCustomerAddress({
      //   addressOne: adr.address_line_1 || "",
      //   addressTwo: adr.address_line_2 || "",
      //   city: adr.city || "",
      //   country:
      //     (adr.country && { value: adr.country, label: adr.country }) || "",
      //   state:
      //     (adr.province && { value: adr.province, label: adr.province }) || "",
      //   zipcode: adr.zipcode || ""
      // })
      setCustomerData({
        firstName: (userDetails && userDetails.firstName) || "",
        lastName: (userDetails && userDetails.lastName) || "",
        // mobile: {
        //   countryCode: (customer && customer.mobile_country_code) || "",
        //   mobileNumber: (customer && customer.mobile) || ""
        // },
        // email: (userDetails && userDetails.email) || "",
        method: "google"
      })
      setActiveStep("shipping")
      setCheckoutMethod("google")
    } catch (error) {
      console.log((error && error.response) || error)
    }
  }

  function loginBackHandler() {
    checkoutMethod && backHandler()
    !checkoutMethod && chooseLogin && chooseLogin("login")
  }

  function renderActiveMethod(method) {
    switch (method) {
      case "guest":
        return (
          <GuestForm
            backHandler={loginBackHandler}
            setCustomerData={setCustomerData}
            customerData={customerData}
            setCustomerAddress={setCustomerAddress}
            deliveryData={deliveryData}
            setSteps={setSteps}
            setActiveStep={setActiveStep}
            setCheckoutMethod={setCheckoutMethod}
            checkoutMethod={checkoutMethod}
            emailLoginHandler={emailLoginHandler}
            showAccountRegister={showAccountRegister}
            setCustomerStatus={setCustomerStatus}
          />
        )
      case "email":
        return (
          <EmailLoginForm
            backHandler={loginBackHandler}
            uuid={uuid}
            account_uuid={account_uuid}
            setCustomerAddress={setCustomerAddress}
            setCustomerData={setCustomerData}
            customerData={customerData}
            setSteps={setSteps}
            setActiveStep={setActiveStep}
            setCheckoutMethod={setCheckoutMethod}
            checkoutMethod={checkoutMethod}
            handleForgotPassword={handleForgotPassword}
            hideForgotPassword={hideForgotPassword}
            handleShowVerifyEmail={handleShowVerifyEmail}
            hideVerifyEmail={hideVerifyEmail}
            setCustomerStatus={setCustomerStatus}
            newOrderAccountUuid={newOrderAccountUuid}
            isNewOrder={isNewOrder}
          />
        )
      case "google":
        return <div>Logged in using Google</div>
      default:
        return (
          <CustomerLoginButtons
            guestLoginHandler={guestLoginHandler}
            emailLoginHandler={emailLoginHandler}
            facebookLoginHandler={facebookLoginHandler}
            googleLoginHandler={googleLoginHandler}
            showAccountRegister={showAccountRegister}
          />
        )
    }
  }
  return (
    <div className="CustomerInfo">
      <CheckSteps steps={steps} setSteps={setSteps} value="info" />
      {checkoutMethod
        ? renderActiveMethod(checkoutMethod)
        : renderActiveMethod(info.active)}
    </div>
  )
}

export default CustomerInfo
